import BaseEvent from './BaseEvent.js';
import { getOSM, getGUI } from '../../OverworldAnimation.js';
import { LEFT, DOWN, UP } from '../../constants.js';

export default class SelectStarterWater extends BaseEvent {
    constructor({
        identifier = 'select_starter_water',
        isActive = true,
        complete = false,
        autoComplete = false,
        objectsIdentifiers = [
            'starter_pokeball_water',
            'starter_pokeball_grass',
            'starter_pokeball_fire',
            'lab_rival',
            'lab_professor',
            'starter_picked',
        ],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new SelectStarterWater({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const gui = getGUI();
        const rival = this.getObject('lab_rival');
        const professor = this.getObject('lab_professor');
        osm.script(async () => {
            if (this.getObject('starter_pokeball_water').pokemon === null) {
                await this.getObject('starter_pokeball_water').createPokemon();
            }
            if (this.getObject('starter_pokeball_grass').pokemon === null) {
                await this.getObject('starter_pokeball_grass').createPokemon();
            }
            if (this.getObject('starter_pokeball_fire').pokemon === null) {
                await this.getObject('starter_pokeball_fire').createPokemon();
            }
        });
        osm.script(() => {
            gui.pokemonPreview.setPokemon(this.getObject('starter_pokeball_water').pokemon);
            gui.pokemonPreview.show();
        });
        osm.readTextAndWait(
            () => `Do you want to select ${this.getObject('starter_pokeball_water').pokemon.name}?`
        );
        osm.menuHandler.handleYesOrNoMenu({ defaultOption: 0, position: { x: 176, y: 64 } });
        osm.script(() => {
            if (osm.yesOrNoMenu.shouldCancel) {
                osm.overworldText = '';
                osm.context.currentEvent.complete = false;
                return;
            }
            if (osm.yesOrNoMenu.yes()) {
                osm.context.currentEvent.complete = true;
                return;
            } else {
                osm.overworldText = '';
                osm.context.currentEvent.complete = false;
            }
        });
        osm.script(() => {
            if (osm.yesOrNoMenu.shouldCancel || osm.yesOrNoMenu.no()) {
                gui.pokemonPreview.hide();
                osm.clearActions();
                osm.yesOrNoMenu.shouldCancel = false;
            }
        });
        osm.script(() => {
            gui.pokemonPreview.hide();
            this.getObject('starter_pokeball_water').visible = false;
        });
        osm.readText(() => `You selected ${this.getObject('starter_pokeball_water').pokemon.name}!`);
        osm.finishReading();
        osm.script(async () => {
            osm.player.acquirePokemon(this.getObject('starter_pokeball_water').pokemon);
            osm.currentMap.getObjectByIdentifier('select_starter_grass').getEvent().complete = true;
            osm.currentMap.getObjectByIdentifier('select_starter_fire').getEvent().complete = true;
            osm.currentMap.getObjectByIdentifier('select_starter_water').getEvent().complete = true;
        });
        osm.script(() => {
            rival.showExclamationMark();
            rival.direction = DOWN;
        });
        osm.delay(30);
        osm.readText(
            () =>
                `I'm glad you picked ${this.getObject('starter_pokeball_water').pokemon.name}!`,
            { speaker: () => rival.name }
        );
        osm.continueReading();
        osm.readText(
            () =>
                `I wanted to pick ${
                    this.getObject('starter_pokeball_grass').pokemon.name
                } anyways!`
        );
        osm.finishReading();
        osm.moveNPC(rival, LEFT, 1);
        osm.script(() => {
            rival.direction = DOWN;
            this.getObject('starter_pokeball_grass').visible = false;
        });
        osm.script(() => {
            osm.currentMap.getEventTriggersByIdentifier('dont_forget_your_starter').forEach((trigger) => {
                trigger.getEvent().complete = true;
            });
        });
        osm.script(() => {
            osm.movePlayer(
                osm.calculateMovementsForPosition({
                    object: osm.player,
                    toPosition: {
                        x: professor.position.x,
                        y: professor.position.y + 16,
                        z: professor.position.z,
                    },
                })
            );
            osm.script(() => {
                osm.player.direction = UP;
            });
            osm.script(() => {
                osm.moveNPCV2(rival, {
                    x: professor.position.x - 16,
                    y: professor.position.y + 16,
                    z: professor.position.z,
                });
                osm.script(() => {
                    rival.direction = UP;
                });
            });
        });
        osm.script(() => {
            osm.currentMap.getObjectByIdentifier('starter_picked').getEvent().isActive = true;
        });
    }
}
